var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { hasValue, toJSON } from "@utils";
export function getViewsByListId(context, listId) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!hasValue(listId)) {
            console.log('List id is empty');
            return [];
        }
        try {
            const res = yield context.executeService('System', 'AccountUserCustomView:GetCustomViewsByListIDAndUser', { UserKey: context.userKey, ListID: listId }, { json: true });
            if (!res || (res === null || res === void 0 ? void 0 : res.length) == 0)
                return [];
            return (res || []).map((cv) => ({
                id: cv.ViewID,
                name: cv.ViewName,
                configurations: toJSON(cv.Configurations),
                isCustom: true,
                key: cv.Key
                // keep group empty to group under custom views
            }));
        }
        catch (e) {
            console.error('Unable to get custom views. Error: ', e);
            return [];
        }
    });
}
export function getFavouritesByListId(context, listId) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!hasValue(listId)) {
            console.log('List id is empty');
            return [];
        }
        try {
            const res = yield context.executeService('System', 'AccountUserFavouriteView:GetFavouriteViewsByListIDAndUser', { UserKey: context.userKey, ListID: listId }, { json: true });
            return res || [];
        }
        catch (e) {
            console.error('Unable to get custom views. Error: ', e);
            return [];
        }
    });
}
export function toggleFavouriteView(context, listId, viewId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const res = yield context.executeService('System', 'AccountUserFavouriteView:ToggleFavouriteViewByListIDAndUser', { UserKey: context.userKey, ListID: listId, ViewID: viewId }, { json: true });
            console.log('response ', res);
        }
        catch (e) {
            console.error('Unable to get custom views. Error: ', e);
        }
    });
}
export function updateView(context, key, name, configurations) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!hasValue(key)) {
            return { data: null, error: 'Key is requied' };
        }
        if (!hasValue(name)) {
            return { data: null, error: 'Name is requied' };
        }
        try {
            const res = yield context.executeService('System', 'AccountUserCustomView:Update', {
                Key: key,
                ViewName: name,
                Configurations: JSON.stringify(configurations)
            }, { json: true });
            return { data: res };
        }
        catch (e) {
            console.error('Unable to save custom view. Error: ', e);
            return { data: null, error: 'Unable to save. soemthing went wrong' };
        }
    });
}
export function createView(context, listId, name, id, configurations) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!hasValue(name)) {
            return { data: null, error: 'Name is requied' };
        }
        try {
            const res = yield context.executeService('System', 'AccountUserCustomView:Create', {
                ListID: listId,
                UserKey: context.userKey,
                ViewID: id,
                ViewName: name,
                Configurations: JSON.stringify(configurations)
            }, { json: true });
            return { data: res };
        }
        catch (e) {
            console.error('Unable to create custom view. Error: ', e);
            return { data: null, error: 'Unable to create. soemthing went wrong' };
        }
    });
}
export function deleteView(context, listId, key) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!hasValue(listId)) {
            return { data: null, error: 'List id is requied' };
        }
        if (!hasValue(key)) {
            return { data: null, error: 'Key is requied' };
        }
        try {
            const res = yield context.executeService('System', 'AccountUserCustomView:Delete', {
                ListID: listId,
                UserKey: context.userKey,
                Key: key
            });
            console.log('response____', res);
            return { data: true };
        }
        catch (e) {
            console.error('Unable to delete custom view. Error: ', e);
            return { data: null, error: 'Unable to delete. soemthing went wrong' };
        }
    });
}
